const U = (id, w = 1800) =>
  `https://images.unsplash.com/${id}?q=80&w=${w}&auto=format&fit=crop`;

export const IMAGES = {
  heroHome: U("photo-1477959858617-67f85cf4f1df"),
  joburg: U("photo-1636706519609-988babca3dd5"),
  technology: U("photo-1518770660439-4636190af475"),
  cloud: U("photo-1558494949-ef010cbdcc31"),
  media: U("photo-1485846234645-a62644f84728"),
  payments: U("photo-1556742049-0cfed4f6a45d"),
  electronics: U("photo-1581091226825-a6a2a5aee158"),
  energy: U("photo-1509391366360-2e959784a276"),
  ev: U("photo-1593941707882-a5bba14938c7"),
  office: U("photo-1497366216548-37526070297c"),
  building: U("photo-1486406146926-c627a92ad1ab"),
  team: U("photo-1519389950473-47ba0277781c"),
  network: U("photo-1451187580459-43490279c0fa"),
  solarSunset: U("photo-1473341304170-971dccb5ac1e"),
  analytics: U("photo-1551288049-bebda4e38f71"),
  retail: U("photo-1441986300917-64674bd600d8"),
  concert: U("photo-1516542076529-1ea3854896f2"),
  cityRoad: U("photo-1449824913935-59a10b8d2000"),
  devices: U("photo-1550745165-9bc0b252726f"),
  music: U("photo-1470225620780-dba8ba36b745"),
};

export const companies = [
  {
    slug: "hapo-technology",
    name: "Hapo Technology",
    tab: "HAPO TECHNOLOGY",
    stage: "Established",
    tabLine:
      "Our founding company — South Africa's trusted B2B technology partner.",
    cardTag: "Delivering enterprise technology South Africa can build on.",
    tagline:
      "The founding company. South Africa's trusted B2B technology partner.",
    overview:
      "Hapo Technology is the company that started it all — a business-to-business technology company and the go-to implementation partner for enterprise clients across South Africa.",
    whatWeDo: [
      {
        title: "Enterprise technology solutions",
        text: "End-to-end enterprise technology solutions and implementation, delivered by a team South African businesses already trust.",
      },
      {
        title: "Long-standing client relationships",
        text: "Trusted relationships across [industries — placeholder], built on years of delivery rather than promises.",
      },
      {
        title: "The foundation of the group",
        text: "The technical and commercial foundation the rest of the Hapo Group is built on.",
      },
    ],
    image: IMAGES.technology,
  },
  {
    slug: "hapo-cloud",
    name: "Hapo Cloud",
    tab: "HAPO CLOUD",
    stage: "Scaling",
    tabLine:
      "Cloud infrastructure, data, and Vision AI — the technical backbone of the group.",
    cardTag: "Powering the group's intelligence, from infrastructure to Vision AI.",
    tagline: "Cloud infrastructure, data, and Vision AI.",
    overview:
      "Hapo Cloud is the technical backbone of the Hapo Group, providing cloud infrastructure, software development, data services, and computer-vision AI capability used across the group and for external clients.",
    whatWeDo: [
      {
        title: "Cloud infrastructure & software",
        text: "Cloud infrastructure and software development for the group and for external enterprise clients.",
      },
      {
        title: "Data services",
        text: "Data pipelines, storage and analytics that turn raw signals into decisions.",
      },
      {
        title: "Vision AI",
        text: "Audience and analytics intelligence for digital displays and retail environments.",
      },
    ],
    image: IMAGES.cloud,
  },
  {
    slug: "hapo-intelligence",
    name: "Hapo Intelligence",
    tab: "HAPO INTELLIGENCE",
    stage: "Early Stage",
    tabLine: "African consumer and market intelligence — know your audience, understand your market.",
    cardTag: "Turning African consumer signals into better business decisions.",
    tagline: "Know your audience. Understand your market. Make better decisions.",
    overview:
      "Hapo Intelligence is an African consumer and market intelligence platform that transforms data into actionable business decisions — built for the realities of African markets.",
    whatWeDo: [
      {
        title: "Audience & cultural intelligence",
        text: "Consumer interests, affinities and the cultural forces — artists, brands, entertainment, destinations — that shape them.",
      },
      {
        title: "Location & retail intelligence",
        text: "Where audiences and commercial opportunities are concentrated, and where demand supports expansion.",
      },
      {
        title: "Media & attention intelligence",
        text: "Connecting audience insight with physical and digital media environments, measured in the real world.",
      },
      {
        title: "Predictive intelligence & Ask Hapo",
        text: "Multiple signals turned into clear recommendations — through a conversational AI interface anyone can use.",
      },
    ],
    image: IMAGES.network,
  },
  {
    slug: "hapo-media",
    name: "Hapo Media",
    tab: "HAPO MEDIA",
    stage: "Early Stage",
    tabLine:
      "Ad-tech and vision-powered media, turning screens into measurable advertising.",
    cardTag: "Turning every screen into a measurable audience.",
    tagline: "Ad-tech and vision-powered media.",
    overview:
      "Hapo Media turns digital displays into measurable, sellable advertising inventory — combining ad-tech with the audience intelligence generated by Hapo Cloud's Vision AI.",
    whatWeDo: [
      {
        title: "Digital-out-of-home advertising",
        text: "DOOH advertising sales across a growing network of premium digital screens.",
      },
      {
        title: "Ad-tech platform",
        text: "Campaign management and ad-tech tooling that makes every placement accountable.",
      },
      {
        title: "Audience measurement",
        text: "Measurement and reporting, powered by Hapo Cloud's Vision AI.",
      },
    ],
    partnerCallout:
      "In partnership with SpaceVision AI — the performance layer for physical retail — Hapo Media measures who watches every screen and for how long. SpaceVision's RetailVision turns existing cameras into anonymous audience measurement: traffic, attention and dwell per screen, with video processed on-site and never stored. Every campaign closes with proof of performance.",
    gallery: true,
    image: IMAGES.media,
  },
  {
    slug: "hapo-sound",
    name: "Hapo Sound",
    tab: "HAPO SOUND",
    stage: "Early Stage",
    tabLine: "Business music streaming — licensed, curated and controlled.",
    cardTag: "Bringing licensed business music to South African venues.",
    tagline: "Music for business, done properly.",
    overview:
      "Hapo Sound brings licensed business music streaming to South Africa — in partnership with Soundtrack, the premium streaming service built for business, with more than 125 million songs and 2,500+ curated playlists made legal for commercial use.",
    whatWeDo: [
      {
        title: "Licensed music for business",
        text: "125 million+ songs and 2,500+ ready-made playlists, fully licensed for commercial environments — no personal-account risk.",
      },
      {
        title: "Curation & scheduling",
        text: "AI-powered playlist generation and expert curation, scheduled ahead of time for every trading hour.",
      },
      {
        title: "Multi-location control",
        text: "Centralised dashboard control across every venue, with instant explicit-lyric blocking and remote management.",
      },
      {
        title: "Setup & hardware",
        text: "From apps to dedicated players and speakers — local installation, support and service.",
      },
    ],
    partnerCallout:
      "In partnership with Soundtrack, the premium music streaming service built for business, Hapo Sound brings fully licensed, curated music to South African venues — with local setup, curation and support.",
    image: IMAGES.music,
  },
  {
    slug: "hapo-payments",
    name: "Hapo Payment Solutions",
    tab: "HAPO PAYMENTS",
    stage: "Early Stage",
    comingSoon: true,
    tabLine: "Fintech, built for South Africa's next generation of digital payments.",
    cardTag: "Building the rails for South Africa's next payment generation.",
    tagline: "Fintech built for South Africa.",
    overview:
      "Hapo Payment Solutions is building the next generation of digital payment solutions for South African businesses and consumers.",
    whatWeDo: [
      {
        title: "Next-generation payments",
        text: "[Payments product description — placeholder, to be finalised once the regulatory/licensing path is confirmed.]",
      },
    ],
    image: IMAGES.payments,
  },
  {
    slug: "hapo-electronics",
    name: "Hapo Electronics",
    tab: "HAPO ELECTRONICS",
    stage: "Early Stage",
    tabLine: "Manufacturing and assembly of LED displays and electronic components.",
    cardTag: "Manufacturing the displays that carry every message.",
    tagline: "Manufacturing tomorrow's displays.",
    overview:
      "Hapo Electronics manufactures and assembles LED displays and electronic components — the hardware backbone behind Hapo Media's screens and a growing external customer base.",
    whatWeDo: [
      {
        title: "Digital Signage",
        text: "Interactive displays that engage customers and drive results.",
      },
      {
        title: "LED Video Walls",
        text: "Stunning large-format displays for maximum visual impact.",
      },
      {
        title: "Content Management",
        text: "Powerful CMS solutions to manage your digital content.",
      },
      {
        title: "Support & Service",
        text: "24/7 technical support and maintenance services.",
      },
    ],
    partnerCallout:
      "In partnership with BOE, a global leader in LED and LCD display panels and smart display systems, Hapo Electronics builds its screens on proven BOE panel technology — manufactured and assembled locally in South Africa.",
    image: IMAGES.electronics,
  },
  {
    slug: "hapo-energy",
    name: "Hapo Energy",
    tab: "HAPO ENERGY",
    stage: "Early Stage",
    tabLine:
      "Green energy and power, including mobile and EV-charging infrastructure.",
    cardTag: "Powering what matters, on-grid or off it.",
    tagline: "Powering South Africa's next generation of infrastructure.",
    overview:
      "Hapo Energy provides green energy and power solutions, from commercial solar and battery storage to mobile power for off-grid and EV-charging infrastructure.",
    whatWeDo: [
      {
        title: "Commercial solar & storage",
        text: "Commercial solar and battery storage engineered for South African conditions.",
      },
      {
        title: "Total cost of energy",
        text: "Total-cost-of-energy solutions that give businesses predictable, lower power costs.",
      },
      {
        title: "Mobile & off-grid power",
        text: "Mobile and off-grid power units, including EV charging infrastructure.",
      },
    ],
    partnerCallout:
      "In partnership with Chargebyte, the East African clean-energy company behind solar-powered charging and connectivity stations serving 20,000+ monthly users, Hapo Energy is developing mobile, battery-powered charging and display units for the South African market.",
    image: IMAGES.energy,
  },
  {
    slug: "xr-africa",
    name: "XR Africa",
    tab: "XR AFRICA",
    stage: "Early Stage",
    tabLine: "Virtual production and extended reality — where virtual meets reality.",
    cardTag: "Africa's pioneering virtual production and XR studio.",
    tagline: "Where virtual meets reality, creativity knows no bounds.",
    overview:
      "XR Africa is a pioneering virtual production and extended reality (XR) facility in Cape Town — transforming the continent's digital content creation landscape through cutting-edge technology, from film and advertising to live events and education.",
    whatWeDo: [
      {
        title: "Virtual production studios",
        text: "A 270-degree LED volume wall, real-time motion capture and a full production control centre — immersive environments without costly location shoots.",
      },
      {
        title: "Extended reality (XR) services",
        text: "AR, VR and MR experiences that blend the physical and digital — brand activations, product visualisation, training simulations and interactive installations.",
      },
      {
        title: "Content & post-production",
        text: "End-to-end content creation: pre-visualisation, VFX, CGI integration, colour grading and finishing — from concept to final output.",
      },
      {
        title: "Events, commercial & training",
        text: "Virtual events, concerts and commercial shoots — plus hands-on training programmes building Africa's next generation of virtual production talent.",
      },
    ],
    image: "/assets/companies/xr-led-stage-wide.jpg",
    cta: { label: "Book the Studio", to: "/contact?regarding=Book the XR Studio" },
    // Showreel slot ready: add e.g. showreel: { type: "video", url: "/assets/xr-showreel.mp4", poster: "/assets/companies/xr-curve-stage.jpg" }
    // or showreel: { type: "embed", url: "https://www.youtube.com/embed/VIDEO_ID" } once footage is available.
    galleryImages: [
      {
        image: "/assets/companies/xr-curve-stage.jpg",
        title: "The CURVE",
        text: "Our 270-degree LED volume stage — 8.4 m by 4 m of immersive backdrop.",
      },
      {
        image: "/assets/companies/xr-studio-metrics.jpg",
        title: "On Set",
        text: "Real-time camera tracking and monitoring during a live shoot.",
      },
      {
        image: "/assets/companies/xr-vr-woman.jpg",
        title: "Immersive Experiences",
        text: "AR, VR and MR content that blends physical and digital worlds.",
      },
    ],
  },
];

export const companyBySlug = (slug) => companies.find((c) => c.slug === slug);

export const whyHapo = [
  {
    num: "01",
    title: "Global Partnerships, Local Delivery",
    text: "We partner with world-class technology and solutions providers and bring them to South Africa, backed by our own manufacturing, delivery, and support.",
    image: IMAGES.network,
  },
  {
    num: "02",
    title: "One Connected Ecosystem",
    text: "Our companies aren't a random collection — Hapo Electronics manufactures the screen, Hapo Energy powers it, Hapo Cloud's Vision AI reads the audience, Hapo Media sells the advertising, and Hapo Intelligence measures it all. One value chain, five companies.",
    link: { to: "/companies", label: "Learn more" },
    image: IMAGES.joburg,
  },
  {
    num: "03",
    title: "Built for the Long Term",
    text: "A holding company structure designed for sound governance, resilience, and sustainable growth across every business we operate.",
    image: IMAGES.building,
  },
  {
    num: "04",
    title: "South African Manufacturing",
    text: "From LED displays to power units, we build and assemble locally, creating local jobs and local supply chains.",
    image: IMAGES.electronics,
  },
];

export const projects = [
  { title: "Indoor Display", image: "/assets/projects/guess-indoor.jpg" },
  { title: "Retail Digital Signage", image: "/assets/projects/cafe365-menu-boards.webp" },
  { title: "Smart Retail Displays", image: "/assets/projects/smart-fridge.webp" },
  { title: "Outdoor Advertising", image: "/assets/projects/outdoor-advertising.webp" },
  { title: "Video Wall", image: "/assets/projects/dior-mall.jpg" },
  { title: "Corporate Video Wall", image: "/assets/projects/corporate-video-wall-new.webp" },
];

export const insights = {
  News: [
    {
      tag: "GROUP NEWS",
      title: "Hapo Group formed as holding company for six operating businesses",
      date: "January 2025",
      image: IMAGES.building,
    },
    {
      tag: "GROUP NEWS",
      title: "Five new operating companies launched under the Hapo Group structure",
      date: "February 2025",
      image: IMAGES.office,
    },
    {
      tag: "GROUP NEWS",
      title: "Hapo Group sets out multi-sector growth strategy for South Africa",
      date: "June 2025",
      image: IMAGES.joburg,
    },
  ],
  Blog: [
    {
      tag: "PERSPECTIVE",
      title: "Why we partner with proven global technology instead of rebuilding it",
      date: "April 2025",
      image: IMAGES.network,
    },
    {
      tag: "PERSPECTIVE",
      title: "The golden thread: how four of our companies form one value chain",
      date: "May 2025",
      image: IMAGES.devices,
    },
    {
      tag: "PERSPECTIVE",
      title: "What Vision AI means for the future of screen advertising",
      date: "June 2025",
      image: IMAGES.analytics,
    },
  ],
  Events: [
    {
      tag: "EVENT",
      title: "Hapo Group showcase: connected screens, power and intelligence",
      date: "September 2025",
      image: IMAGES.concert,
    },
    {
      tag: "EVENT",
      title: "Hapo Energy partner briefing on mobile EV charging infrastructure",
      date: "October 2025",
      image: IMAGES.ev,
    },
    {
      tag: "EVENT",
      title: "Hapo Electronics open day at our LED assembly facility",
      date: "November 2025",
      image: IMAGES.electronics,
    },
  ],
  Partnerships: [
    {
      tag: "PARTNERSHIP",
      title: "Hapo Energy signs global EV charging technology partnership",
      date: "March 2025",
      image: IMAGES.ev,
    },
    {
      tag: "PARTNERSHIP",
      title: "Hapo Cloud teams up with a global computer-vision analytics specialist",
      date: "April 2025",
      image: IMAGES.cloud,
    },
    {
      tag: "PARTNERSHIP",
      title: "Open call: proven global solutions seeking a South African partner",
      date: "Ongoing",
      image: IMAGES.team,
    },
  ],
};

export const timeline = [
  {
    num: "01",
    when: "2014",
    title: "Hapo Technology founded",
    text: "The founding company becomes a trusted B2B technology partner for South African enterprise clients.",
  },
  {
    num: "02",
    when: "2025",
    title: "Hapo Group formed",
    text: "Eight new operating companies launched: Hapo Cloud, Hapo Media, Hapo Payment Solutions, Hapo Electronics, Hapo Energy, Hapo Intelligence, Hapo Sound and XR Africa.",
  },
  {
    num: "03",
    when: "2026+",
    title: "Scaling the group",
    text: "Scaling each company and its partnerships into a significant South African multi-sector group.",
  },
];

export const partners = [
  {
    name: "SpaceVision AI",
    with: "Hapo Media",
    field: "Vision AI — audience measurement",
    text: "SpaceVision AI is the performance layer for physical retail. Its RetailVision platform measures who watches every screen and for how long — video processed on-site, never stored, no identities. Hapo Media uses SpaceVision's measurement to make every campaign provable.",
    logoColor: "/assets/partners/spacevision-color.webp",
    logoWhite: "/assets/partners/spacevision-white.webp",
    image: IMAGES.analytics,
  },
  {
    name: "Soundtrack",
    with: "Hapo Sound",
    field: "Business music streaming",
    text: "Soundtrack is the premium music streaming service built for business — more than 125 million songs and 2,500+ curated playlists, fully licensed for commercial use. Hapo Sound brings Soundtrack to South African venues with local setup, curation and support.",
    logoColor: "/assets/partners/soundtrack.png",
    logoWhite: "/assets/partners/soundtrack.png",
    image: IMAGES.music,
  },
  {
    name: "BOE",
    with: "Hapo Electronics",
    field: "LED & LCD display panels",
    text: "BOE is a global leader in display panels and smart display systems, from digital signage to video walls and Mini/Micro LED. Hapo Electronics builds its screens on proven BOE panel technology, manufactured and assembled locally.",
    logoColor: "/assets/partners/boe-black.png",
    logoWhite: "/assets/partners/boe-white.png",
    image: IMAGES.electronics,
  },
  {
    name: "Qloo",
    with: "Hapo Intelligence",
    field: "Cultural intelligence data",
    text: "Qloo is the cultural intelligence layer for AI — the world's largest catalog of people, places, brands and interests, linked by trillions of anonymized behavioural signals. Qloo's culture data grounds the audience and cultural intelligence inside Hapo Intelligence.",
    logoColor: "/assets/partners/qloo-dark.svg",
    logoWhite: "/assets/partners/qloo-white.svg",
    image: IMAGES.network,
  },
  {
    name: "Chargebyte",
    with: "Hapo Energy",
    field: "Clean energy & charging infrastructure",
    text: "Chargebyte builds solar-powered charging and connectivity stations across East Africa — locally manufactured, IoT-enabled and data-driven, with 38+ stations serving 20,000+ monthly users in Kenya and Rwanda. With Hapo Energy, that proven model comes to South Africa as mobile, battery-powered charging and display units.",
    logoColor: "/assets/partners/chargebyte.png",
    logoWhite: "/assets/partners/chargebyte.png",
    image: "/assets/partners/chargebyte-station.jpg",
  },
];


// Brand assets: real logo files in /public/assets/logos (white variants for dark surfaces)
const logoPack = {
  "hapo-technology": ["technology-white.webp", "technology.webp"],
  "hapo-cloud": ["cloud-white.webp", "cloud.webp"],
  "hapo-intelligence": ["intel.webp", "intel-dark.webp"],
  "hapo-sound": ["sound-white.webp", "sound-dark.webp"],
  "hapo-media": ["media-white.webp", "media.webp"],
  "hapo-payments": ["pay-white.webp", "pay.webp"],
  "hapo-electronics": ["electronics-white.webp", "electronics.webp"],
  "hapo-energy": ["energy-white.webp", "energy.webp"],
  "xr-africa": ["xr-white.webp", "xr.webp"],
};
companies.forEach((c) => {
  const pack = logoPack[c.slug];
  if (pack) {
    c.logoOnDark = `/assets/logos/${pack[0]}`;
    c.logoOnLight = `/assets/logos/${pack[1]}`;
  }
});

companyBySlug("hapo-cloud").products = [
  {
    name: "Hapo Intelligence",
    logoOnDark: "/assets/logos/intel.webp",
    logoOnLight: "/assets/logos/intel-dark.webp",
    text: "Hapo Intelligence is an African consumer and market intelligence platform developed in-house by the Hapo Cloud team — transforming audience behaviour, cultural affinities, location and real-world consumer signals into actionable business decisions.",
    link: { to: "/companies/hapo-intelligence", label: "Explore Hapo Intelligence" },
  },
];

// Brand logos: official SVG/transparent PNG versions (no baked backgrounds)
export const brands = [
  { name: "Coca-Cola", logo: "/assets/brands/coca-cola.svg" },
  { name: "Adidas", logo: "/assets/brands/adidas.png" },
  { name: "Total", logo: "/assets/brands/total.png" },
  { name: "Hoka", logo: "/assets/brands/hoka.png" },
  { name: "Engen", logo: "/assets/brands/engen.png" },
  { name: "Pick n Pay", logo: "/assets/brands/picknpay.png" },
  { name: "Spar", logo: "/assets/brands/spar.png" },
  { name: "Ackermans", logo: "/assets/brands/ackermans.svg" },
  { name: "Canal Walk", logo: "/assets/brands/canal-walk.png" },
  { name: "OpenAI", logo: "/assets/brands/openai.svg" },
  { name: "Classic Oriental Consultancy", logo: "/assets/brands/classic-oriental.png" },
];

export const solutions = [
  {
    num: "01",
    title: "Enterprise Technology & Implementation",
    text: "End-to-end enterprise technology solutions and implementation, delivered by the team South African businesses have trusted since 2014.",
    deliveredBy: ["hapo-technology"],
    image: IMAGES.technology,
  },
  {
    num: "02",
    title: "Cloud, Data & Software",
    text: "Cloud infrastructure, software development and data services — the technical backbone behind the group and its enterprise clients.",
    deliveredBy: ["hapo-cloud"],
    image: IMAGES.cloud,
  },
  {
    num: "03",
    title: "Consumer & Market Intelligence",
    text: "African audience, cultural, location and media intelligence that turns real-world consumer signals into better business decisions.",
    deliveredBy: ["hapo-intelligence"],
    image: IMAGES.network,
  },
  {
    num: "04",
    title: "Digital-Out-of-Home Advertising",
    text: "Premium digital screen networks with campaign management and Vision-AI-powered audience measurement — every placement accountable, every campaign provable.",
    deliveredBy: ["hapo-media", "hapo-cloud"],
    image: IMAGES.media,
  },
  {
    num: "05",
    title: "Business Music & In-Store Audio",
    text: "Fully licensed music streaming for business — 125 million+ songs, expert curation, scheduling and multi-location control, with local setup and support.",
    deliveredBy: ["hapo-sound"],
    image: IMAGES.music,
  },
  {
    num: "06",
    title: "LED Displays & Digital Signage",
    text: "Locally manufactured and assembled LED video walls, interactive displays and digital signage — built on proven global panel technology.",
    deliveredBy: ["hapo-electronics"],
    image: IMAGES.electronics,
  },
  {
    num: "07",
    title: "Green Energy & EV Charging",
    text: "Commercial solar and battery storage, mobile off-grid power and EV-charging infrastructure engineered for South African conditions.",
    deliveredBy: ["hapo-energy"],
    image: IMAGES.energy,
  },
  {
    num: "08",
    title: "Digital Payments",
    text: "The next generation of digital payment solutions for South African businesses and consumers — currently in development.",
    deliveredBy: ["hapo-payments"],
    image: IMAGES.payments,
    comingSoon: true,
  },
  {
    num: "09",
    title: "Virtual Production & Extended Reality",
    text: "270-degree LED volume stages, real-time motion capture, AR/VR/MR experiences and full post-production — immersive content for film, advertising, live events and training.",
    deliveredBy: ["xr-africa"],
    image: "/assets/companies/xr-vr-woman.jpg",
  },
];

// Vacancies are managed via the Site Manager (DB-backed), seeded on first backend startup.
